import React from 'react'
import {Icon, Badge, Dropdown, Menu, Modal, Table, message} from 'antd'
import screenfull from 'screenfull'
import {inject, observer} from 'mobx-react'
import {Link, withRouter} from 'react-router-dom'
import {isAuthenticated} from '../../utils/Session'
import SiderNav from '../../components/SiderNav'
import * as HttpUtils from "../DoFetch/doFetch";
import {isStringEmpty} from '../../utils/utils'

function Render({if: cond, children}) {
    return cond ? children : null
}

//withRouter一定要写在前面，不然路由变化不会反映到props中去
@withRouter @inject('appStore') @observer
class HeaderBar extends React.Component {
    state = {
        icon: 'arrows-alt',
        count: 100,
        visible: false,
        avatar: require('./img/01.jpg'),
        tabTitleList: [
            {
                title: '设备编号',
                dataIndex: 'bid',
                key: 'bid',
            },
            {
                title: '告警时间',
                dataIndex: 'faultRecordCreateTime',
                key: 'faultRecordCreateTime',
            },
            {
                title: '告警类型',
                dataIndex: 'moduleName',
                key: 'moduleName',
            },
            // {
            //     title: '操作',
            //     dataIndex: 'action',
            //     key: 'action',
            //     render: (text, record) => (
            //             <span>
            //                <a>解除警告 </a>
            //                 {/*<a>立即监控</a>*/}
            //             </span>
            //     ),
            // },
        ],
        tabContentList: [],
        nowPage: 1,
        totalNum: '',
        applyShow: false,
        applyTableLsit: [
            {
                title: '时间',
                dataIndex: 'createTime',
                key: 'createTime',
            },
            {
                title: '姓名',
                dataIndex: 'realName',
                key: 'realName',
            },
            {
                title: '手机号码',
                dataIndex: 'phone',
                key: 'phone',
            },
            {
                title: '所在地区',
                dataIndex: 'addressInfo',
                key: 'addressInfo',
            },
            {
                title: '备注',
                dataIndex: 'remark',
                key: 'remark',
            },
            {
                title: '状态',
                dataIndex: 'state',
                key: 'state',
                render: (text, record) => (
                    <span>
                        {record.state == 1 ? <a style={{color: '#6FBA2C'}}>已沟通</a> : <a style={{color: 'red'}}> 未沟通</a>}

                        {/*<a>立即监控</a>*/}
                    </span>
                ),
            },
            {
                title: '操作',
                dataIndex: 'action',
                key: 'action',
                render: (text, record) => (
                    <span>
                          {record.state == 1 ? '' : <a onClick={this.changeApplyState.bind(this, record.id)}>已沟通</a>}
                        {/*<a>立即监控</a>*/}
                    </span>
                ),
            },
        ],
        applyDataLsit: [],
    }

    componentDidMount() {

        screenfull.onchange(() => {
            this.setState({
                icon: screenfull.isFullscreen ? 'shrink' : 'arrows-alt'
            })
        })
    }

    componentWillUnmount() {
        screenfull.off('change')
    }


    logout = () => {
        this.props.appStore.toggleLogin(false)
        this.props.history.push(this.props.location.pathname)
    }


    render() {
        const {icon, count, visible, avatar} = this.state
        const {appStore, collapsed, location} = this.props

        return (
            <div id='headerbar' style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                background: '#fff'
            }}>
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    {/*<Icon*/}
                    {/*type={collapsed ? 'menu-unfold' : 'menu-fold'}*/}
                    {/*className='trigger'*/}
                    {/*onClick={this.toggle}/>*/}
                    {/*<SiderNav/>*/}
                </div>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                    {/*<Link to={'/home/agent'} replace>*/}
                    {/*<div style={{marginRight: '20px', cursor: 'pointer'}} onClick={this.showApplyModal}>*/}
                    {/*<img style={{height:'12px',width:'17px'}} src={require('../../assets/img/ico1.png')} alt=""/>*/}
                    {/*<span style={{marginLeft: '8px',color:'#333'}}>代理商申请</span>*/}
                    {/*</div>*/}
                    {/*</Link>*/}


                    <div>
                        <span style={{marginRight: '10px', fontSize: 16}}>后台管理员</span>
                        {/*<img src={avatar} style={{width: '40px', height: '40px', borderRadius: '50%'}} alt=""/>*/}
                    </div>

                    <div style={{marginRight: '20px', cursor: 'pointer'}} onClick={this.logout}>

                        <span style={{marginLeft: '8px', color: '#333', fontSize: 16}}>退出登录</span>
                    </div>
                </div>


            </div>
        )
    }
}

export default HeaderBar


// WEBPACK FOOTER //
// ./src/components/HeaderBar/index.js